<template>

  <div :class="['py-5 px-3', 'bk-'+ section]" id="box-techdata">
    <div class="container">

      <h2 class="text-center mb-5">
        Technical <br v-if="section == 'ab-yachts'" class="d-lg-none">
        data
      </h2>

      <div class="row mb-5">
        <div class="col-12 col-lg-6" v-for="x in totEntries" :key="x">
          <TechData :techData="pageItem.techData[x - 1]" />
        </div>
      </div>
    </div>
   </div>

</template>

<script>
  import TechData from './TechData.vue'

  export default {
    name: 'YachtTechdata',
		props: ['section', 'pageItem'],
    computed: {
      totEntries() {
        if (!this.pageItem || !this.pageItem.techData) return null
        return this.pageItem.techData.length
      },
      /*techEntries() {
        if (!this.totEntries) return null
        console.log(this.totEntries % 2)
        let nEntries = ((this.totEntries % 2) === 0) ? this.totEntries / 2 : Math.ceil(this.totEntries / 2)
        return nEntries
      },*/
    },
    components: {
      TechData
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
